/**
 * bootprompt.js locale configuration
 * locale : Japanese
 * author : ms183
 */

import { addLocale } from "../bootprompt";

addLocale("ja", {
  OK: "OK",
  CANCEL: "キャンセル",
  CONFIRM: "確認",
});
